import styled from "styled-components";
import { SIZES } from "common/constants/sizes.contants";

export const EditUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${SIZES.smallDesktop}px;

  @media (max-width: ${SIZES.smallDesktop}px) {
    padding: 0 25px;
  }
`;

export const EditUserContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media (max-width: ${SIZES.bigTablet}px) {
    width: 70%;
  }

  @media (max-width: ${SIZES.smallTablet}px) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;
`;

export const EditUserFormContainer = styled.div`
  margin-top: 30px;
`;
